import
{
    USERSSCREEN_LOAD,
    USERSSCREEN_UNLOAD,
    USERSSCREEN_SET,
} from '../../../../actionDefinitions';
import { createReducer } from '../../../../reducerUtils';

const initialState =
{
    //allTeams
};

const handlers = {
    [USERSSCREEN_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [USERSSCREEN_UNLOAD]: () => initialState,
    [USERSSCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
